<style lang="scss" scoped>


</style>

<template>
    <div class="row">
        <div class="col pt-2">
            <div ref="nouislider"></div>
        </div>
        <div class="col-auto">
            <imask-input type="text" v-model="value_input" v-on:keyup="onValueChange" :mask="mask" class="form-control" style="width: 53px;" :disabled="disabled" />
        </div>                               
    </div>
</template>

<script>

import noUiSlider from 'nouislider';
import { IMaskComponent } from 'vue-imask';

export default {
    name: 'RangeSliderInput',
    components: {
        'imask-input': IMaskComponent
    },    
    props: {
        value: {
            type: Number,
            default: null
        },
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 100
        },
        mask: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            slider: null,
            value_input: '0'
        }
    },
    created: function () {
    },
    methods: {
        onValueChange: function () {  
            let self = this;
            let value = parseInt(self.value_input);

            self.slider.set(value);
            self.$emit('update:value', value);
        }
    },    
    mounted: function () {
        let self = this;
        
        if (self.slider) {
            self.slider.destroy();
        }
        
        let value = self.value ? self.value: 0;
        
        self.value_input = String(value);
        
        self.slider = noUiSlider.create(
            this.$refs.nouislider ,{
                start: value,
                connect: [true, false],
                range: {
                    'min': self.min,
                    'max': self.max
                },
                step: 1,
                tooltips: false,
                _format: {
                    to: function (value) {
                        return value + ' mm';
                    },
                    from: function (value) {
                        return Number(value.replace(' mm', ''));
                    }
                }
        })
        
        self.slider.on('slide', function (values) {
            let value = parseInt(values[0].replace(' mm', ''));
            self.value_input = String(value);
            self.$emit('update:value', value);
        });
        
    },
    watch: {
        value: function (new_value, old_value) {
            if (new_value !==  old_value) {
                this.value_input = this.value ? String(this.value): '';
                this.slider.set(this.value);
            }
        },
        disabled: function (new_value, old_value) {
            if (new_value !==  old_value) {
                if (new_value === true) {
                    this.$refs.nouislider.setAttribute('disabled', true);
                } else {
                    this.$refs.nouislider.removeAttribute('disabled');
                }
            }            
        }
    }
}
</script>